export { default } from "./Price"